
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.0002 18.17L19.0002 16.17V14H18.0002C16.9002 14 16.0002 13.1 16.0002 12V6C16.0002 4.51 17.6002 2.68 19.7602 2.15C20.3902 2 21.0002 2.48 21.0002 3.13V18.17ZM21.1902 22.61C20.8002 23 20.1702 23 19.7802 22.61L10.0202 12.85C9.69016 12.94 9.36016 13 9.00016 13V21C9.00016 21.55 8.55016 22 8.00016 22C7.45016 22 7.00016 21.55 7.00016 21V13C4.79016 13 3.00016 11.21 3.00016 9V5.83L1.39016 4.22C1.00016 3.83 1.00016 3.2 1.39016 2.81C1.78016 2.42 2.41016 2.42 2.80016 2.81L21.1802 21.19C21.5802 21.58 21.5802 22.22 21.1902 22.61ZM6.17016 9L5.00016 7.83V9H6.17016ZM13.0002 9V3C13.0002 2.45 12.5502 2 12.0002 2C11.4502 2 11.0002 2.45 11.0002 3V8.17L12.8502 10.02C12.9402 9.69 13.0002 9.36 13.0002 9ZM9.00016 3C9.00016 2.45 8.55016 2 8.00016 2C7.45016 2 7.00016 2.45 7.00016 3V4.17L9.00016 6.17V3Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-no-meals`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNoMeals

    ```js
    <b-new-b-icon-no-meals />
    ```
</docs>


